import { render } from "./EditWorkspaceDetailsChallengeEditor.vue?vue&type=template&id=53e76234"
import script from "./EditWorkspaceDetailsChallengeEditor.vue?vue&type=script&lang=js"
export * from "./EditWorkspaceDetailsChallengeEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/hoxer/Dokumenter/GitHub/techecute/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QKnob from 'quasar/src/components/knob/QKnob.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QKnob});
